var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdp-top" },
    [
      _vm._t("breadcrumbs"),
      _vm._v(" "),
      _c("div", { staticClass: "container container--flush" }, [
        _c(
          "div",
          { staticClass: "product-block-list product-block-list--medium" },
          [
            _c(
              "div",
              { staticClass: "product-block-list__wrapper" },
              [
                _c("div"),
                _vm._v(" "),
                _vm.hasImages
                  ? [
                      _c("ProductGallery", {
                        key: _vm.componentKey,
                        attrs: {
                          media: _vm.productData.product.media,
                          productTitle: _vm.selectedVariant.title
                        }
                      })
                    ]
                  : [
                      _c("img", {
                        staticClass: "product-card__image placeholder",
                        attrs: {
                          src: _vm.placeholderImage,
                          alt: "Product Placeholder Image"
                        }
                      })
                    ],
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "product-block-list__item product-block-list__item--info"
                  },
                  [
                    _vm.selectedVariant.variants
                      ? _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card__section" }, [
                            _vm.selectedVariant.variants
                              ? _c(
                                  "div",
                                  { staticClass: "product-meta" },
                                  [
                                    !_vm.productData.isConfigureOneTemplate &&
                                    !_vm.hasRestrictWebSale
                                      ? [
                                          _vm.productData.product.type ==
                                          "variant"
                                            ? [
                                                _vm.childProducts.length > 0
                                                  ? _c("span", {
                                                      staticClass:
                                                        "product-meta__price",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.convertCurrency(
                                                            _vm.selectedVariant
                                                              .variants[0].price
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                (
                                                  _vm.currentPrice * 100
                                                ).toFixed(0) <
                                                  _vm.selectedVariant
                                                    .variants[0].price &&
                                                _vm.childProducts.length > 0
                                                  ? _c("span", {
                                                      staticClass:
                                                        "product-meta__compare-at-price",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.selectedVariant
                                                              .variants[0].price
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            : _vm.productTemplate == "sets"
                                            ? void 0
                                            : _vm.isSetsProductType
                                            ? void 0
                                            : [
                                                _c("span", {
                                                  staticClass:
                                                    "product-meta__price",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.convertCurrency(
                                                        _vm.selectedVariant
                                                          .variants[0].price
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                (
                                                  _vm.currentPrice * 100
                                                ).toFixed(0) <
                                                _vm.selectedVariant.variants[0]
                                                  .price
                                                  ? _c("span", {
                                                      staticClass:
                                                        "product-meta__compare-at-price",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.selectedVariant
                                                              .variants[0].price
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-meta__reference"
                                      },
                                      [
                                        _vm.hasCustomBadge
                                          ? _c("span", {
                                              staticClass:
                                                "product-meta__badge",
                                              class: _vm.customBadgeColor,
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.customBadgeText
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.productData.isConfigureOneTemplate
                                          ? [
                                              _vm.productData.product.type ==
                                              "variant"
                                                ? [
                                                    _vm.selectedVariant
                                                      .variants[0].sku &&
                                                    _vm.childProducts.length > 0
                                                      ? _c("span", {
                                                          staticClass:
                                                            "product-meta__sku",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm
                                                                .selectedVariant
                                                                .variants[0].sku
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                : [
                                                    _vm.selectedVariant
                                                      .variants[0].sku
                                                      ? _c("span", {
                                                          staticClass:
                                                            "product-meta__sku",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm
                                                                .selectedVariant
                                                                .variants[0].sku
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                              _vm._v(" "),
                                              _vm.hasRestrictWebSale
                                                ? _c("span", {
                                                    staticClass:
                                                      "product-meta__stock-status available"
                                                  })
                                                : _vm.selectedVariant.available
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product-meta__stock-status available"
                                                    },
                                                    [
                                                      _c("Icon", {
                                                        attrs: {
                                                          name: "checkmark",
                                                          size: "16px"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                      In Stock\n                    "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm.hasRestrictWebSale
                                                ? _c("span", {
                                                    staticClass:
                                                      "product-meta__stock-status unavailable"
                                                  })
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product-meta__stock-status unavailable"
                                                    },
                                                    [
                                                      _c("Icon", {
                                                        attrs: {
                                                          name: "close",
                                                          size: "16px"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                      Out Of Stock\n                    "
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("h1", {
                                      staticClass: "product-meta__title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.productData.product.title
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product-meta__prop-65-holder"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "mobile-margins",
                                            attrs: {
                                              target: "_blank",
                                              href:
                                                _vm.productData.prop65Link ||
                                                "#"
                                            }
                                          },
                                          [
                                            _c("Icon", {
                                              attrs: {
                                                name: "prop-65",
                                                size: "16px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "product-meta__prop-65"
                                              },
                                              [
                                                _vm._v(
                                                  "California Residents – Proposition 65"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.productData.product.type == "variant" &&
                                    _vm.childProducts.length > 0
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "product-meta__selected"
                                            },
                                            [
                                              _vm._v("Selected: "),
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.selectedVariant
                                                      .variants[0].name
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product-meta__variant-box"
                                            },
                                            [
                                              _vm._l(
                                                _vm.childProducts,
                                                function(variant) {
                                                  return [
                                                    _c("button", {
                                                      key:
                                                        variant.products[0]
                                                          .variants[0].sku,
                                                      staticClass:
                                                        "product-meta__variant-card",
                                                      class: [
                                                        _vm.selectedVariant ===
                                                        variant.products[0]
                                                          ? "active"
                                                          : ""
                                                      ],
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          variant.products[0]
                                                            .variants[0].sku
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.changeVariant(
                                                            variant.products[0]
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "select-wrapper select-wrapper--primary mobile-margins"
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: {
                                                  name: "chevron-down",
                                                  size: "16px"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "select",
                                                {
                                                  domProps: {
                                                    value:
                                                      _vm.selectedVariant
                                                        .variants[0].id
                                                  },
                                                  on: {
                                                    change: value =>
                                                      _vm.changeVariantDropdown(
                                                        value
                                                      )
                                                  }
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.childProducts,
                                                    function(variant) {
                                                      return [
                                                        _c("option", {
                                                          key:
                                                            variant.products[0]
                                                              .variants[0].sku,
                                                          domProps: {
                                                            value:
                                                              variant
                                                                .products[0]
                                                                .variants[0].id,
                                                            innerHTML: _vm._s(
                                                              variant
                                                                .products[0]
                                                                .variants[0]
                                                                .name
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.changeVariant(
                                                                variant
                                                                  .products[0]
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : _vm.productData.product.type == "master"
                                      ? void 0
                                      : void 0,
                                    _vm._v(" "),
                                    _vm.isToolStorage
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "notify-me-space" },
                                            [
                                              JSON.parse(this.data)
                                                .klaviyoToggle
                                                ? _c("div", [
                                                    _c("h2", [
                                                      _vm._v(
                                                        "Subscribe for back in stock notifications"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    !JSON.parse(_vm.data)
                                                      .customer
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form__input-wrapper form__input-wrapper--labelled"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.email,
                                                                    expression:
                                                                      "email"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form__field form__field--text",
                                                                attrs: {
                                                                  type: "email",
                                                                  required: ""
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.email
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.email =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form__floating-label",
                                                                  attrs: {
                                                                    for:
                                                                      "Subscribe email notification"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Your email"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticStyle: {
                                                        "margin-bottom": "10px"
                                                      },
                                                      attrs: { id: "errorMsg" }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button button--primary",
                                                        attrs: {
                                                          id: "notify",
                                                          primary: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.notifyMe(
                                                              _vm.email,
                                                              JSON.parse(
                                                                _vm.data
                                                              ).product
                                                                .variants[0].id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("NOTIFY ME")]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("br")
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(0)
                                        ]
                                      : _vm.hasRestrictWebSale
                                      ? [_vm._m(1)]
                                      : _vm.hasReplacement
                                      ? [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button button--primary disabled",
                                              attrs: { disabled: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addToCart(
                                                    _vm.selectedVariant
                                                      .variants[0].id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Discontinued")]
                                          )
                                        ]
                                      : _vm.isStudent
                                      ? [
                                          _vm.hasMTSchool
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button button--primary disabled",
                                                    attrs: { disabled: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addToCart(
                                                          _vm.selectedVariant
                                                            .variants[0].id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Not Available")]
                                                )
                                              ]
                                            : !_vm.isAvailable
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "notify-me-space"
                                                  },
                                                  [
                                                    JSON.parse(this.data)
                                                      .klaviyoToggle
                                                      ? _c("div", [
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Subscribe for back in stock notifications"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          !JSON.parse(_vm.data)
                                                            .customer
                                                            ? _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form__input-wrapper form__input-wrapper--labelled"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.email,
                                                                            expression:
                                                                              "email"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form__field form__field--text",
                                                                        attrs: {
                                                                          type:
                                                                            "email",
                                                                          required:
                                                                            ""
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            _vm.email
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            if (
                                                                              $event
                                                                                .target
                                                                                .composing
                                                                            )
                                                                              return
                                                                            _vm.email =
                                                                              $event.target.value
                                                                          }
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "form__floating-label",
                                                                        attrs: {
                                                                          for:
                                                                            "Subscribe email notification"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Your email"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "10px"
                                                            },
                                                            attrs: {
                                                              id: "errorMsg"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "button button--primary",
                                                              attrs: {
                                                                id: "notify",
                                                                primary: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.notifyMe(
                                                                    _vm.email,
                                                                    JSON.parse(
                                                                      _vm.data
                                                                    ).product
                                                                      .variants[0]
                                                                      .id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "NOTIFY ME"
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("br")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._m(2)
                                              ]
                                            : _vm.discontinueEmpty
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "product-form__holder mobile-margins"
                                                  },
                                                  [
                                                    !_vm.productData
                                                      .isConfigureOneTemplate
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "product-form__info-item product-form__info-item--quantity"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "product-form__info-content"
                                                              },
                                                              [
                                                                _vm.hasMinQtyAboveOne
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "quantity-selector quantity-selector--product one"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "quantity-selector__button",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Decrease quantity",
                                                                              title:
                                                                                "Decrease quantity"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                ;[
                                                                                  _vm.quantity >
                                                                                  _vm.getMinQtyAboveOne()
                                                                                    ? (_vm.quantity =
                                                                                        parseInt(
                                                                                          _vm.quantity
                                                                                        ) -
                                                                                        _vm.getPackQtyAboveOne)
                                                                                    : _vm.quantity
                                                                                ]
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "Icon",
                                                                              {
                                                                                attrs: {
                                                                                  name:
                                                                                    "minus",
                                                                                  size:
                                                                                    "16px"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm.quantity,
                                                                                expression:
                                                                                  "quantity"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "quantity-selector__value",
                                                                            attrs: {
                                                                              id:
                                                                                "quantity-input",
                                                                              name:
                                                                                "quantity",
                                                                              "aria-label":
                                                                                "Quantity",
                                                                              inputmode:
                                                                                "numeric",
                                                                              value:
                                                                                "1",
                                                                              size:
                                                                                "3"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm.quantity
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.quantity =
                                                                                  $event.target.value
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "quantity-selector__button",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Increase quantity",
                                                                              title:
                                                                                "Increase quantity"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                _vm.quantity =
                                                                                  parseInt(
                                                                                    _vm.quantity
                                                                                  ) +
                                                                                  _vm.getPackQtyAboveOne
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "Icon",
                                                                              {
                                                                                attrs: {
                                                                                  name:
                                                                                    "plus",
                                                                                  size:
                                                                                    "16px"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "quantity-selector quantity-selector--product three"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "quantity-selector__button",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Decrease quantity",
                                                                              title:
                                                                                "Decrease quantity",
                                                                              disabled:
                                                                                _vm.isStudent &&
                                                                                !_vm.hasBeenPurchased
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                ;[
                                                                                  _vm.quantity >
                                                                                  1
                                                                                    ? _vm.quantity--
                                                                                    : _vm.quantity
                                                                                ]
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "Icon",
                                                                              {
                                                                                attrs: {
                                                                                  name:
                                                                                    "minus",
                                                                                  size:
                                                                                    "16px"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm.quantity,
                                                                                expression:
                                                                                  "quantity"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "quantity-selector__value",
                                                                            attrs: {
                                                                              id:
                                                                                "quantity-input",
                                                                              name:
                                                                                "quantity",
                                                                              "aria-label":
                                                                                "Quantity",
                                                                              inputmode:
                                                                                "numeric",
                                                                              value:
                                                                                "1",
                                                                              size:
                                                                                "3",
                                                                              disabled:
                                                                                _vm.isStudent &&
                                                                                !_vm.hasBeenPurchased
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm.quantity
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.quantity =
                                                                                  $event.target.value
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "quantity-selector__button",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Increase quantity",
                                                                              title:
                                                                                "Increase quantity",
                                                                              disabled:
                                                                                _vm.isStudent &&
                                                                                !_vm.hasBeenPurchased
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                _vm.quantity++
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "Icon",
                                                                              {
                                                                                attrs: {
                                                                                  name:
                                                                                    "plus",
                                                                                  size:
                                                                                    "16px"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.hasMinQtyAboveOne
                                                              ? _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "product-form__info-title",
                                                                    attrs: {
                                                                      for:
                                                                        "quantity-input"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Qty (Minimum " +
                                                                        _vm._s(
                                                                          _vm.getMinQtyAboveOne()
                                                                        ) +
                                                                        " Qty required)"
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "product-form__info-title",
                                                                    attrs: {
                                                                      for:
                                                                        "quantity-input"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Qty"
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.productData
                                                      .isConfigureOneTemplate &&
                                                    _vm.isQuickview &&
                                                    _vm.isSetsProductType
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "button button--primary add-to-cart-main",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addToCartSet(
                                                                  _vm
                                                                    .selectedVariant
                                                                    .variants[0]
                                                                    .id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Add to cart"
                                                            )
                                                          ]
                                                        )
                                                      : !_vm.productData
                                                          .isConfigureOneTemplate
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "button button--primary add-to-cart-main",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addToCart(
                                                                  _vm
                                                                    .selectedVariant
                                                                    .variants[0]
                                                                    .id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Add to cart"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "button button--primary",
                                                            attrs: {
                                                              href:
                                                                _vm.productData
                                                                  .configureOneCtaUrl
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.productData
                                                                  .configureOneCtaText
                                                              )
                                                            )
                                                          ]
                                                        )
                                                  ]
                                                )
                                              ]
                                            : !_vm.discontinueEmpty
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button button--primary disabled",
                                                    attrs: { disabled: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addToCart(
                                                          _vm.selectedVariant
                                                            .variants[0].id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Discontinued")]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button button--primary disabled",
                                                    attrs: { disabled: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addToCart(
                                                          _vm.selectedVariant
                                                            .variants[0].id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Not Available")]
                                                )
                                              ]
                                        ]
                                      : _vm.isStudent && !_vm.studentCanBuy
                                      ? [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button button--primary disabled",
                                              attrs: { disabled: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addToCart(
                                                    _vm.selectedVariant
                                                      .variants[0].id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Not Available")]
                                          )
                                        ]
                                      : _vm.hasBeenPurchased
                                      ? [_vm._m(3)]
                                      : !_vm.hasSalesChannelFlag
                                      ? [_vm._m(4)]
                                      : [
                                          !_vm.isAvailable
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "notify-me-space"
                                                  },
                                                  [
                                                    JSON.parse(this.data)
                                                      .klaviyoToggle
                                                      ? _c("div", [
                                                          JSON.parse(_vm.data)
                                                            .customer
                                                            ? _c("div")
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Subscribe for back in stock notifications"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          !JSON.parse(_vm.data)
                                                            .customer
                                                            ? _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form__input-wrapper form__input-wrapper--labelled"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.email,
                                                                            expression:
                                                                              "email"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form__field form__field--text",
                                                                        attrs: {
                                                                          type:
                                                                            "email",
                                                                          required:
                                                                            ""
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            _vm.email
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            if (
                                                                              $event
                                                                                .target
                                                                                .composing
                                                                            )
                                                                              return
                                                                            _vm.email =
                                                                              $event.target.value
                                                                          }
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "form__floating-label",
                                                                        attrs: {
                                                                          for:
                                                                            "Subscribe email notification"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Your email"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "10px"
                                                            },
                                                            attrs: {
                                                              id: "errorMsg"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "button button--primary",
                                                              attrs: {
                                                                id: "notify",
                                                                primary: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.notifyMe(
                                                                    _vm.email,
                                                                    JSON.parse(
                                                                      _vm.data
                                                                    ).product
                                                                      .variants[0]
                                                                      .id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "NOTIFY ME"
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("br")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._m(5)
                                              ]
                                            : [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "product-form__holder mobile-margins",
                                                    style: [
                                                      _vm.isSetsProductType
                                                        ? {
                                                            "padding-bottom":
                                                              "15px"
                                                          }
                                                        : ""
                                                    ]
                                                  },
                                                  [
                                                    !_vm.isSetsProductType
                                                      ? [
                                                          !_vm.productData
                                                            .isConfigureOneTemplate
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "product-form__info-item product-form__info-item--quantity"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "product-form__info-content"
                                                                    },
                                                                    [
                                                                      _vm.hasMinQtyAboveOne
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "quantity-selector quantity-selector--product two"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "button",
                                                                                {
                                                                                  staticClass:
                                                                                    "quantity-selector__button",
                                                                                  attrs: {
                                                                                    type:
                                                                                      "button",
                                                                                    "aria-label":
                                                                                      "Decrease quantity",
                                                                                    title:
                                                                                      "Decrease quantity"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      ;[
                                                                                        _vm.quantity >
                                                                                        _vm.getMinQtyAboveOne()
                                                                                          ? (_vm.quantity =
                                                                                              parseInt(
                                                                                                _vm.quantity
                                                                                              ) -
                                                                                              _vm.getPackQtyAboveOne)
                                                                                          : _vm.quantity
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        name:
                                                                                          "minus",
                                                                                        size:
                                                                                          "16px"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        _vm.quantity,
                                                                                      expression:
                                                                                        "quantity"
                                                                                    }
                                                                                  ],
                                                                                  staticClass:
                                                                                    "quantity-selector__value",
                                                                                  attrs: {
                                                                                    id:
                                                                                      "quantity-input",
                                                                                    name:
                                                                                      "quantity",
                                                                                    "aria-label":
                                                                                      "Quantity",
                                                                                    inputmode:
                                                                                      "numeric",
                                                                                    value:
                                                                                      "1",
                                                                                    size:
                                                                                      "3"
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      _vm.quantity
                                                                                  },
                                                                                  on: {
                                                                                    input: function(
                                                                                      $event
                                                                                    ) {
                                                                                      if (
                                                                                        $event
                                                                                          .target
                                                                                          .composing
                                                                                      )
                                                                                        return
                                                                                      _vm.quantity =
                                                                                        $event.target.value
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "button",
                                                                                {
                                                                                  staticClass:
                                                                                    "quantity-selector__button",
                                                                                  attrs: {
                                                                                    type:
                                                                                      "button",
                                                                                    "aria-label":
                                                                                      "Increase quantity",
                                                                                    title:
                                                                                      "Increase quantity"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.quantity =
                                                                                        parseInt(
                                                                                          _vm.quantity
                                                                                        ) +
                                                                                        _vm.getPackQtyAboveOne
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        name:
                                                                                          "plus",
                                                                                        size:
                                                                                          "16px"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "quantity-selector quantity-selector--product four"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "button",
                                                                                {
                                                                                  staticClass:
                                                                                    "quantity-selector__button",
                                                                                  attrs: {
                                                                                    type:
                                                                                      "button",
                                                                                    "aria-label":
                                                                                      "Decrease quantity",
                                                                                    title:
                                                                                      "Decrease quantity"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      ;[
                                                                                        _vm.quantity >
                                                                                        1
                                                                                          ? _vm.quantity--
                                                                                          : _vm.quantity
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        name:
                                                                                          "minus",
                                                                                        size:
                                                                                          "16px"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "model",
                                                                                      rawName:
                                                                                        "v-model",
                                                                                      value:
                                                                                        _vm.quantity,
                                                                                      expression:
                                                                                        "quantity"
                                                                                    }
                                                                                  ],
                                                                                  staticClass:
                                                                                    "quantity-selector__value",
                                                                                  attrs: {
                                                                                    id:
                                                                                      "quantity-input",
                                                                                    name:
                                                                                      "quantity",
                                                                                    "aria-label":
                                                                                      "Quantity",
                                                                                    inputmode:
                                                                                      "numeric",
                                                                                    value:
                                                                                      "1",
                                                                                    size:
                                                                                      "3"
                                                                                  },
                                                                                  domProps: {
                                                                                    value:
                                                                                      _vm.quantity
                                                                                  },
                                                                                  on: {
                                                                                    input: function(
                                                                                      $event
                                                                                    ) {
                                                                                      if (
                                                                                        $event
                                                                                          .target
                                                                                          .composing
                                                                                      )
                                                                                        return
                                                                                      _vm.quantity =
                                                                                        $event.target.value
                                                                                    }
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "button",
                                                                                {
                                                                                  staticClass:
                                                                                    "quantity-selector__button",
                                                                                  attrs: {
                                                                                    type:
                                                                                      "button",
                                                                                    "aria-label":
                                                                                      "Increase quantity",
                                                                                    title:
                                                                                      "Increase quantity"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.quantity++
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        name:
                                                                                          "plus",
                                                                                        size:
                                                                                          "16px"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.hasMinQtyAboveOne
                                                                    ? _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "product-form__info-title",
                                                                          attrs: {
                                                                            for:
                                                                              "quantity-input"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Qty (Minimum " +
                                                                              _vm._s(
                                                                                _vm.getMinQtyAboveOne()
                                                                              ) +
                                                                              " Qty required)"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "product-form__info-title",
                                                                          attrs: {
                                                                            for:
                                                                              "quantity-input"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Qty"
                                                                          )
                                                                        ]
                                                                      )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.productTemplate ==
                                                          "sets"
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary add-to-cart-main"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add to cart"
                                                                  )
                                                                ]
                                                              )
                                                            : !_vm.productData
                                                                .isConfigureOneTemplate
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary add-to-cart-main",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.addToCart(
                                                                        _vm
                                                                          .selectedVariant
                                                                          .variants[0]
                                                                          .id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add to cart"
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary",
                                                                  attrs: {
                                                                    href:
                                                                      _vm
                                                                        .productData
                                                                        .configureOneCtaUrl
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .productData
                                                                        .configureOneCtaText
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                          _vm._v(" "),
                                                          _vm.isQuickview
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary",
                                                                  attrs: {
                                                                    href: `/products/${_vm.productData.product.handle}`
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "View Product"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      : [
                                                          _vm.productTemplate ==
                                                          "sets"
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary add-to-cart-main"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add to cart"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.isQuickview
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "button button--primary add-to-cart-main",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.addToCartSet(
                                                                        _vm
                                                                          .selectedVariant
                                                                          .variants[0]
                                                                          .id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add to cart"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ]
                                        ],
                                    _vm._v(" "),
                                    _vm.descriptionData.contents
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "product-meta__accordion-holder"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-meta__accordion-title",
                                                attrs: { tabindex: "0" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.descriptionAccordion = !_vm.descriptionAccordion
                                                  },
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    _vm.descriptionAccordion = !_vm.descriptionAccordion
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Product Description\n                    "
                                                ),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.descriptionAccordion,
                                                      expression:
                                                        "!descriptionAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "plus",
                                                    size: "20px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.descriptionAccordion,
                                                      expression:
                                                        "descriptionAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "minus",
                                                    size: "20px"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "product-meta__accordion-content",
                                              class: [
                                                _vm.descriptionAccordion
                                                  ? "active"
                                                  : ""
                                              ],
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.descriptionData.contents
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasWarrantyInfo
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "product-meta__accordion-holder second"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-meta__accordion-title",
                                                attrs: { tabindex: "0" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.warrantyAccordion = !_vm.warrantyAccordion
                                                  },
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    _vm.warrantyAccordion = !_vm.warrantyAccordion
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Warranty Info\n                    "
                                                ),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.warrantyAccordion,
                                                      expression:
                                                        "!warrantyAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "plus",
                                                    size: "20px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.warrantyAccordion,
                                                      expression:
                                                        "warrantyAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "minus",
                                                    size: "20px"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-meta__accordion-content",
                                                class: [
                                                  _vm.warrantyAccordion
                                                    ? "active"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm.warrantyText != undefined
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "product-meta__warranty-holder"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "product-meta__warranty-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Warranty Code"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          staticClass:
                                                            "product-meta__warranty-content",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.warrantyText
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.productData.ServiceInfo != null
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "product-meta__accordion-holder second"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-meta__accordion-title",
                                                attrs: { tabindex: "0" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.serviceAccordion = !_vm.serviceAccordion
                                                  },
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    _vm.serviceAccordion = !_vm.serviceAccordion
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Service Info\n                    "
                                                ),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.serviceAccordion,
                                                      expression:
                                                        "!serviceAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "plus",
                                                    size: "20px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("Icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.serviceAccordion,
                                                      expression:
                                                        "serviceAccordion"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "product-meta__accordion-button",
                                                  attrs: {
                                                    name: "minus",
                                                    size: "20px"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "product-meta__accordion-content",
                                              class: [
                                                _vm.serviceAccordion
                                                  ? "active"
                                                  : ""
                                              ],
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.descriptionData.contents
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.productData.product.type == "variant"
                                      ? [
                                          _vm.BVAGlobal.customerTags != null &&
                                          _vm.childProducts.length > 0 &&
                                          !_vm.hasRestrictWebSale
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "product-meta__wishlist-btn product-form__cart-submit",
                                                  attrs: {
                                                    type: "button",
                                                    name: "addToWishList",
                                                    id: "addToWishList"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleWishlist(
                                                        _vm.selectedVariant.id,
                                                        _vm.selectedVariant
                                                          .handle,
                                                        _vm.selectedVariant
                                                          .variants[0].id,
                                                        _vm.selectedVariant
                                                          .title
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.wishlistLoaderVisible
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "wishListLoader"
                                                            }
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "checkmark",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "heart-empty"
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "heart-empty",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "heart-full"
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "heart-full",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        id: "addToWishListText"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Add to Wishlist "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      : [
                                          _vm.BVAGlobal.customerTags != null &&
                                          !_vm.hasRestrictWebSale
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "product-meta__wishlist-btn product-form__cart-submit",
                                                  attrs: {
                                                    type: "button",
                                                    name: "addToWishList",
                                                    id: "addToWishList"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleWishlist(
                                                        _vm.selectedVariant.id,
                                                        _vm.selectedVariant
                                                          .handle,
                                                        _vm.selectedVariant
                                                          .variants[0].id,
                                                        _vm.selectedVariant
                                                          .title
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.wishlistLoaderVisible
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "wishListLoader"
                                                            }
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "checkmark",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "heart-empty"
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "heart-empty",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "heart-full"
                                                          },
                                                          [
                                                            _c("Icon", {
                                                              attrs: {
                                                                name:
                                                                  "heart-full",
                                                                size: "16px"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        id: "addToWishListText"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Add to Wishlist "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ],
              2
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                      Please contact us for ordering information at\n                      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available for purchase online!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                      Please contact us for ordering information at\n                      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                        Please contact us for ordering information at\n                        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available for purchase online!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                      Please contact us for ordering information at\n                      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available for purchase online!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                      Please contact us for ordering information at\n                      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-meta__warning-box" }, [
      _c("p", { staticClass: "product-meta__warning-strong" }, [
        _vm._v("This item is not available!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "product-meta__warning-content" }, [
        _vm._v(
          "\n                        Please contact us for ordering information at\n                        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("(800) MAC-TOOLS")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }